// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1JZiy","options":"AnswerScale_options__3ejVH","selected":"AnswerScale_selected__3vsZM"};